import React, { useRef, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { logOut } from '../firebase/authMethods';
import './UsernameOnboarding.css';

export default function UsernameOnboarding({ user, required, onComplete, onDismiss }) {
  const [editing, setEditing] = useState(required);
  const [username, setUsername] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const lock = useRef(false);

  const request = async (url, method, body) => {
    const token = await user.getIdToken();
    const response = await fetch(url, {
      method, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body || {}),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to save. Please try again.');
    return data;
  };

  const run = async (action) => {
    if (lock.current) return;
    lock.current = true;
    setBusy(true);
    setError('');
    try { await action(); }
    catch (err) { setError(err.message); }
    finally { lock.current = false; setBusy(false); }
  };
  const dismiss = () => {
    if (required) return;
    run(async () => {
      await request('/api/username-reminder/dismiss', 'POST');
      onDismiss();
    });
  };
  const save = (event) => {
    event.preventDefault();
    const value = username.trim();
    if (value.length < 3 || value.length > 20) {
      setError('Username must be between 3 and 20 characters.');
      return;
    }
    run(async () => {
      const data = await request(required ? '/api/save-user' : '/api/username', required ? 'POST' : 'PUT', { username: value });
      onComplete(data);
    });
  };

  return <Modal show centered scrollable className='username-onboarding-modal' backdropClassName='username-onboarding-backdrop' backdrop={required || busy ? 'static' : true}
    keyboard={!required && !busy} onHide={dismiss} aria-labelledby='username-onboarding-title'>
    <Modal.Header className='bg-lightgreen text-white' closeButton={!required && !busy}>
      <Modal.Title id='username-onboarding-title' className='h5 fw-bold'>
        {editing ? 'Choose your username' : 'Make your profile yours!'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className='bg-lightgreen text-white'>
      {editing ? <Form id='username-onboarding-form' onSubmit={save}>
        <p>{required ? 'Choose a public username to finish signing up with Google.' : 'Choose the name other players will see.'}</p>
        <Form.Label htmlFor='onboarding-username'>Username</Form.Label>
        <Form.Control id='onboarding-username' autoFocus required minLength={3} maxLength={20}
          autoComplete='nickname' value={username} disabled={busy}
          onChange={(event) => { setUsername(event.target.value); setError(''); }} />
        <div className='small text-end mt-1'>{username.length}/20 characters</div>
      </Form> : <p className='mb-0'>Hey! You can change your username. Pick a name that feels like you. You can change it here or anytime in Account settings.</p>}
      {error && <p role='alert' className='text-orange mt-2 mb-0'>{error}</p>}
    </Modal.Body>
    <Modal.Footer className='bg-lightgreen border-0'>
      {required
        ? <button type='button' className='btn btn-outline-light' disabled={busy} onClick={() => run(logOut)}>Sign out</button>
        : <button type='button' className='btn btn-outline-light' disabled={busy} onClick={dismiss}>Maybe later</button>}
      {editing
        ? <button type='submit' form='username-onboarding-form' className='btn btn-prim text-white fw-bold'
          disabled={busy || username.trim().length < 3}>{busy ? 'Saving…' : required ? 'Finish sign-up' : 'Save username'}</button>
        : <button type='button' className='btn btn-prim text-white fw-bold' disabled={busy} onClick={() => setEditing(true)}>Change username</button>}
    </Modal.Footer>
  </Modal>;
}
